const currency = {
  EUR: {
    name: 'EUR',
    viewBox: '0 0 24 25',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M15.7476 18.0578C13.4137 18.1483 11.2227 16.9325 10.0656 14.9027C9.07058 13.1397 9.07058 10.9853 10.0656 9.2223C11.2227 7.1933 13.4137 5.97669 15.7476 6.06722',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M8.25195 13.8242H15.2482',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M8.25195 10.3027H15.2482',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  USD: {
    name: 'USD',
    viewBox: '0 0 24 25',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M9.00007 16.7295H13.3335C14.6223 16.7295 15.6665 15.6853 15.6665 14.3965C15.6665 13.1077 14.6223 12.0626 13.3335 12.0626H10.6669C9.37807 12.0626 8.33301 11.0184 8.33301 9.72954C8.33301 8.44072 9.37807 7.39648 10.6669 7.39648H15.0003',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M12.002 19.0625V5.0625',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  RUB: {
    name: 'RUB',
    viewBox: '0 0 25 25',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M8.42254 6.0625C8.42254 5.64829 8.75833 5.3125 9.17254 5.3125H13.4666C15.6824 5.3125 17.4775 7.10883 17.4775 9.32413C17.4775 11.5386 15.6825 13.3356 13.467 13.3366H9.92254V18.0625C9.92254 18.4767 9.58675 18.8125 9.17254 18.8125C8.75833 18.8125 8.42254 18.4767 8.42254 18.0625V13.3366H7.77246C7.35825 13.3366 7.02246 13.0008 7.02246 12.5866C7.02246 12.1723 7.35825 11.8366 7.77246 11.8366H8.42254V6.0625ZM9.92254 11.8366H13.4663C13.4664 11.8366 13.4662 11.8366 13.4663 11.8366C14.8532 11.8358 15.9775 10.7106 15.9775 9.32413C15.9775 7.93678 14.8535 6.8125 13.4666 6.8125H9.92254V11.8366Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M7.02539 15.5137C7.02539 15.0995 7.36118 14.7637 7.77539 14.7637H11.5368C11.951 14.7637 12.2868 15.0995 12.2868 15.5137C12.2868 15.9279 11.951 16.2637 11.5368 16.2637H7.77539C7.36118 16.2637 7.02539 15.9279 7.02539 15.5137Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      }
    ]
  }
}
const types = {
  email: {
    name: 'email',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M15.6 8.6413V12.899C15.6 14.3906 16.8084 15.599 18.3 15.599C19.9589 15.599 21 14.2369 21 12C21 6.93859 16.9699 3 11.999 3C7.02908 3 3 7.03005 3 12.001C3 16.9709 7.03005 21 12.001 21C13.8146 21 15.5825 20.4522 17.0741 19.4335',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M12.0004 8.39941C13.9882 8.39941 15.6004 10.0116 15.6004 11.9994C15.6004 13.9882 13.9882 15.5994 12.0004 15.5994C10.0126 15.5994 8.40039 13.9882 8.40039 11.9994C8.40039 10.0116 10.0126 8.39941 12.0004 8.39941Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  facebook: {
    name: 'facebook',
    viewBox: '0 0 24 25',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M13.957 7.73279C14.04 7.65379 14.146 7.60879 14.25 7.60879H16.95C17.227 7.60879 17.45 7.38479 17.45 7.10879V3.50879C17.45 3.23279 17.227 3.00879 16.95 3.00879H14.25C12.944 3.00879 11.656 3.53879 10.714 4.46579C9.77005 5.41579 9.25005 6.67379 9.25005 8.00879V10.2098H7.05005C6.77305 10.2098 6.55005 10.4328 6.55005 10.7098V14.3088C6.55005 14.5858 6.77305 14.8088 7.05005 14.8088H9.25005V21.5088C9.25005 21.7858 9.47405 22.0088 9.75005 22.0088H13.35C13.626 22.0088 13.85 21.7858 13.85 21.5088V14.8088H16.95C17.227 14.8088 17.45 14.5858 17.45 14.3088V10.7098C17.45 10.4328 17.227 10.2098 16.95 10.2098H13.85V8.00879C13.85 7.90079 13.892 7.79879 13.957 7.73279Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      }
    ]
  },
  flashcall: {
    name: 'flashcall',
    viewBox: '0 0 24 25',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M5.33648 12.5501L9.03976 3.51392C9.12288 3.28734 9.33857 3.13672 9.57991 3.13672H14.5445C14.9415 3.13672 15.2192 3.52943 15.0869 3.90381L12.8914 9.05654C12.7591 9.43092 13.0368 9.82363 13.4339 9.82363H18.1217C18.6162 9.82363 18.8803 10.4062 18.5544 10.7781L9.65365 20.9376C9.25258 21.3954 8.50815 20.9983 8.66496 20.4102L10.3617 14.0472C10.4591 13.6819 10.1838 13.3236 9.80578 13.3236H5.87664C5.47667 13.3236 5.19874 12.9256 5.33648 12.5501Z',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  instagram: {
    name: 'instagram',
    viewBox: '0 0 24 25',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M11.8446 10.0886C10.3266 10.0886 9.09155 11.3216 9.09155 12.8386C9.09155 14.3556 10.3266 15.5886 11.8446 15.5886C13.3626 15.5886 14.5966 14.3556 14.5966 12.8386C14.5966 11.3216 13.3626 10.0886 11.8446 10.0886Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M16.864 8.91779C16.294 8.91779 15.829 8.45579 15.829 7.88879C15.829 7.31979 16.294 6.85779 16.864 6.85779C17.434 6.85779 17.898 7.31979 17.898 7.88879C17.898 8.45579 17.434 8.91779 16.864 8.91779ZM11.844 17.0888C9.5 17.0888 7.592 15.1828 7.592 12.8388C7.592 10.4948 9.5 8.58879 11.844 8.58879C14.189 8.58879 16.096 10.4948 16.096 12.8388C16.096 15.1828 14.189 17.0888 11.844 17.0888ZM16.217 3.00879H7.782C4.623 3.00879 2.5 5.23079 2.5 8.53879V16.4788C2.5 19.7858 4.623 22.0088 7.782 22.0088H16.216C19.376 22.0088 21.5 19.7858 21.5 16.4788V8.53879C21.5 5.23079 19.377 3.00879 16.217 3.00879Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      }
    ]
  },
  ok: {
    name: 'ok',
    viewBox: '0 0 320 512',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M275.1 334c-27.4 17.4-65.1 24.3-90 26.9l20.9 20.6 76.3 76.3c27.9 28.6-17.5 73.3-45.7 45.7-19.1-19.4-47.1-47.4-76.3-76.6L84 503.4c-28.2 27.5-73.6-17.6-45.4-45.7 19.4-19.4 47.1-47.4 76.3-76.3l20.6-20.6c-24.6-2.6-62.9-9.1-90.6-26.9-32.6-21-46.9-33.3-34.3-59 7.4-14.6 27.7-26.9 54.6-5.7 0 0 36.3 28.9 94.9 28.9s94.9-28.9 94.9-28.9c26.9-21.1 47.1-8.9 54.6 5.7 12.4 25.7-1.9 38-34.5 59.1zM30.3 129.7C30.3 58 88.6 0 160 0s129.7 58 129.7 129.7c0 71.4-58.3 129.4-129.7 129.4s-129.7-58-129.7-129.4zm66 0c0 35.1 28.6 63.7 63.7 63.7s63.7-28.6 63.7-63.7c0-35.4-28.6-64-63.7-64s-63.7 28.6-63.7 64z'
        }
      }
    ]
  },
  push: {
    name: 'push',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M8.5,15.8476424 C14.13923,15.8476424 16.7480515,15.1242108 17,12.220506 C17,9.31879687 15.1811526,9.50539234 15.1811526,5.94511102 C15.1811526,3.16414015 12.5452291,-1.86517468e-14 8.5,-1.86517468e-14 C4.4547709,-1.86517468e-14 1.81884743,3.16414015 1.81884743,5.94511102 C1.81884743,9.50539234 0,9.31879687 0,12.220506 C0.252952291,15.135187 2.86177374,15.8476424 8.5,15.8476424 Z',
          'stroke-width': '1.5',
          transform: 'translate(3.500000, 2.000000)'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M10.8887931,18.8572176 C9.52465753,20.3719337 7.3966462,20.3898948 6.0194615,18.8572176',
          'stroke-width': '1.5',
          transform: 'translate(3.500000, 2.000000)'
        }
      }
    ]
  },
  vk: {
    name: 'vk',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M12.0966 18.0956C10.1966 18.0956 8.18661 17.1556 6.56661 15.4756C5.56661 14.4956 4.84661 13.2756 4.15661 12.0956L3.98661 11.8056C3.26661 10.5156 2.76661 9.35559 2.42661 8.22559L2.39661 8.09558C2.27661 7.65558 2.10661 6.98562 2.45661 6.44562C2.58661 6.24562 2.83661 5.98558 3.30661 5.90558C3.33661 5.90558 3.37661 5.90558 3.40661 5.90558C3.85661 5.89558 4.30661 5.89563 4.75661 5.89563C5.02661 5.89563 5.30661 5.89563 5.58661 5.89563C6.79661 5.85563 7.15661 6.9156 7.34661 7.4856L7.39661 7.63562C7.80661 8.74562 8.44661 10.2956 9.39661 11.4256V9.03559C9.37661 8.78559 9.31661 8.3856 9.07661 8.1156C8.66661 7.6056 8.54661 7.04558 8.75661 6.59558C8.84661 6.39558 9.14661 5.92558 9.93661 5.90558H11.2066C11.8566 5.90558 12.4966 5.90558 13.1366 5.90558C13.1766 5.90558 13.2066 5.90558 13.2466 5.90558C13.7166 5.98558 14.2666 6.3056 14.2666 7.4256V10.6556C15.0866 9.67558 15.8066 8.46563 16.5266 6.83563C16.8066 6.23563 17.3566 5.89563 18.0466 5.89563H20.0566C20.7466 5.89563 21.0666 6.26559 21.1966 6.47559C21.6166 7.19559 21.1766 8.12562 20.7266 8.94562L20.6666 9.05561C20.0866 10.0856 19.4366 11.0456 18.8066 11.9856L18.5766 12.3356C18.5766 12.3356 18.6466 12.4256 18.6766 12.4556L18.7566 12.5556L19.2366 13.0456C20.0166 13.8456 20.8166 14.6856 21.4266 15.6956C21.7666 16.2656 21.8466 16.8656 21.6366 17.3256C21.4666 17.7156 21.1066 17.9756 20.6466 18.0656C20.6166 18.0656 20.5766 18.0756 20.5366 18.0756C20.2566 18.0856 19.9766 18.0856 19.6966 18.0856H18.9366C18.2666 18.0856 17.6866 18.0856 16.9166 17.4656C16.6466 17.1956 16.4466 16.9556 16.2366 16.7256C15.6166 16.0256 14.9866 15.2956 14.2666 14.9656C14.2666 15.2056 14.2666 15.4556 14.2666 15.6956C14.2666 16.0756 14.2666 16.4556 14.2566 16.8356C14.1966 17.4756 13.7166 17.9256 13.0266 18.0256C12.7266 18.0756 12.4066 18.1056 12.0966 18.1056V18.0956ZM3.76661 7.38562C3.78661 7.50562 3.82661 7.63558 3.84661 7.71558L3.87661 7.82562C4.17661 8.81562 4.63661 9.8856 5.28661 11.0556L5.45661 11.3356C6.10661 12.4256 6.77661 13.5656 7.64661 14.4156C9.19661 16.0256 11.1166 16.8156 12.7766 16.5356C12.7766 16.2756 12.7766 15.9856 12.7766 15.6956C12.7766 15.4056 12.7766 15.1056 12.7766 14.8156C12.7766 14.7756 12.7766 14.7356 12.7866 14.6956C12.8466 14.3756 12.9466 13.8256 13.4266 13.5456C13.8566 13.2856 14.3366 13.3956 14.6466 13.4956C15.8066 13.9556 16.6366 14.9056 17.3666 15.7356C17.5566 15.9556 17.7466 16.1756 17.9366 16.3756C18.2166 16.5956 18.3466 16.5956 18.9266 16.5956H19.7066C19.8666 16.5956 20.0366 16.5956 20.1966 16.5956C20.1766 16.5556 20.1566 16.5156 20.1366 16.4756C19.6166 15.6056 18.9066 14.8656 18.1466 14.0956L17.4966 13.3956C17.2366 13.0656 16.7466 12.4456 17.2666 11.5956L17.5666 11.1556C18.1766 10.2456 18.8166 9.30558 19.3566 8.34558L19.4166 8.2356C19.6366 7.8356 19.7566 7.57558 19.8166 7.40558H18.0566C17.9066 7.40558 17.9066 7.43558 17.8966 7.46558C17.1066 9.23558 16.3066 10.5856 15.3766 11.6756C14.6266 12.5656 14.0066 12.5856 13.6166 12.4456C13.2366 12.3056 12.7766 11.9156 12.7666 10.8156V7.40558C12.2466 7.40558 11.7266 7.40558 11.2066 7.40558H10.4066C10.6866 7.83558 10.8566 8.38561 10.8866 8.99561V11.5556V11.7456C10.8866 12.0156 10.8866 12.3356 10.8066 12.6656C10.6766 13.0556 10.4266 13.2956 10.1066 13.3856C9.56661 13.5356 9.06661 13.2056 8.80661 12.9956C7.35661 11.6156 6.49661 9.57558 5.97661 8.15558L5.91661 7.97559C5.85661 7.79559 5.74661 7.46558 5.66661 7.40558C5.31661 7.40558 5.02661 7.40558 4.74661 7.40558C4.41661 7.40558 4.08661 7.40558 3.75661 7.40558L3.76661 7.38562Z'
        }
      }
    ]
  },
  hlr: {
    name: 'hlr',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M20.6704 10.2004L17.5704 4.84043C16.9904 3.83043 15.9004 3.19043 14.7304 3.19043H8.46045C7.29045 3.19043 6.20045 3.82043 5.62045 4.83043L2.52045 10.1904C1.94045 11.2004 1.94045 12.4604 2.52045 13.4704L5.62045 18.8304C6.20045 19.8504 7.29045 20.4804 8.46045 20.4804H12.508C12.8159 20.4804 12.9496 20.0298 12.7159 19.8294C11.4464 18.741 10.6404 17.1223 10.6404 15.3104C10.6404 15.2413 10.6426 15.1742 10.6458 15.1074C10.6526 14.9684 10.5659 14.8429 10.4363 14.7922C9.25378 14.3294 8.42045 13.1869 8.42045 11.8404C8.42045 10.0804 9.84045 8.66043 11.5904 8.66043C12.5337 8.66043 13.3846 9.07134 13.9668 9.72422C14.0606 9.82946 14.2112 9.86713 14.3414 9.81303C15.0339 9.52532 15.7959 9.37043 16.5904 9.37043C18.0305 9.37043 19.3476 9.88174 20.3751 10.7325C20.6024 10.9208 20.9341 10.746 20.8126 10.477C20.7702 10.3833 20.7229 10.291 20.6704 10.2004Z',
          opacity: '.3',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M21.1317 20.0144C20.9857 20.1604 20.7937 20.2344 20.6017 20.2344C20.4097 20.2344 20.2177 20.1604 20.0707 20.0144L18.7716 18.7152C18.1526 19.1102 17.4226 19.3462 16.6356 19.3462C14.4336 19.3462 12.6426 17.5562 12.6426 15.3562C12.6426 13.1562 14.4336 11.3652 16.6356 11.3652C18.8376 11.3652 20.6286 13.1562 20.6286 15.3562C20.6286 16.2282 20.3396 17.0282 19.8626 17.6862L21.1317 18.9534C21.4247 19.2464 21.4247 19.7214 21.1317 20.0144ZM16.6355 12.8661C18.0105 12.8661 19.1285 13.9831 19.1285 15.3561C19.1285 16.7291 18.0105 17.8461 16.6355 17.8461C15.2605 17.8461 14.1425 16.7291 14.1425 15.3561C14.1425 13.9831 15.2605 12.8661 16.6355 12.8661Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      }
    ]
  },
  sms: {
    name: 'sms',
    viewBox: '0 0 512 512',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z'
        }
      }
    ]
  },
  web: {
    name: 'web',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M6.47294 16.157C8.3731 15.6676 11.3834 15.0751 14.9794 14.9983C16.4894 14.9652 17.4876 13.4231 16.862 12.0483L14.201 6.19899C13.2427 4.09257 11.4242 3.83279 10.4065 4.9507C7.98392 7.61267 5.55643 9.49336 3.93941 10.6035C2.89447 11.3205 2.78063 12.5708 3.30602 13.7247L3.69714 14.5857C4.2235 15.7426 5.24217 16.4742 6.47294 16.157Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M11.2888 15.2529L12.6295 18.197C13.0158 19.0474 12.6412 20.0651 11.7762 20.4582C10.9191 20.8483 9.90526 20.463 9.51803 19.6117L7.80273 15.8425',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M5.51367 9.4873L6.84076 12.4052',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M20.403 10.8268C21.1211 9.46663 21.2232 7.80096 20.5373 6.2929C19.8339 4.7469 18.462 3.71655 16.9189 3.38867',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M18.1783 9.73196C18.4644 9.02171 18.4702 8.20055 18.1287 7.44846C17.796 6.71876 17.1986 6.1924 16.502 5.93359',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  telegram: {
    name: 'telegram',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M12.5131 15.9608L10.1876 17.9466C9.77411 18.2988 9.13291 18.078 9.02491 17.5458L8.13859 13.1849L3.8418 12.64C2.86006 12.5154 2.68297 11.1688 3.59856 10.7942L19.7433 4.18663C20.4264 3.90739 21.1405 4.51356 20.9761 5.2326L17.8061 19.1093C17.632 19.8731 16.6843 20.1456 16.1306 19.5919L10.8512 14.3135',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M8.13867 13.1822L15.4293 8.27344',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  viber: {
    name: 'viber',
    viewBox: '0 0 512 512',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9.4-85.7.4-85.7-.1 0-.1 0 0 0-101.8-28.2-95.8-134.3-94.7-189.8 1.1-55.5 11.6-101 42.6-131.6 55.7-50.5 170.4-43 170.4-43 96.9.4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5.9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z'
        }
      }
    ]
  },
  voice: {
    name: 'voice',
    viewBox: '0 0 640 512',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z'
        }
      }
    ]
  },
  whatsapp: {
    name: 'whatsapp',
    viewBox: '0 0 448 512',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z'
        }
      }
    ]
  },
  sim_push: {
    name: 'sim_push',
    viewBox: '0 0 24 25',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M9.12917 3.62109H8.31967C6.32117 3.62109 4.70117 5.24108 4.70117 7.24008L4.70207 18.0041C4.70207 20.0011 6.32207 21.6211 8.31967 21.6211H13.8354C15.8339 21.6211 17.453 20.0011 17.453 18.0031L17.452 13.5391',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M12.2363 5.53308C12.8853 4.39108 14.1132 3.62109 15.5211 3.62109C16.0367 3.62109 16.5281 3.7241 16.9757 3.9111',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M18.6094 5.21875C19.0433 5.83375 19.2983 6.58374 19.2983 7.39374V10.1988',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M16.9764 10.1579V7.53488C16.9764 6.71288 16.3109 6.04688 15.4888 6.04688C14.6676 6.04688 14.002 6.71288 14.002 7.53488V7.93289',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M14.0018 11.0573V9.71927M11.7461 9.32928V7.86328V9.32928Z',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M11.0757 17.8873V17.8243V17.8873ZM10.8164 17.8743C10.8164 17.7303 10.9333 17.6133 11.0773 17.6133C11.2213 17.6133 11.338 17.7303 11.338 17.8743C11.338 18.0183 11.2213 18.1353 11.0773 18.1353C10.9333 18.1353 10.8164 18.0183 10.8164 17.8743Z',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  chat: {
    name: 'chat',
    viewBox: '0 0 512 512',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288z'
        }
      }
    ]
  }
}

export const svgIcons = {
  ...types,
  ...currency,

  ai: {
    name: 'ai',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M9.76022 3.84961C8.97589 3.84961 8.32594 4.46479 8.27404 5.25234C8.25888 5.48227 8.13887 5.69248 7.94857 5.82241C7.75826 5.95235 7.51879 5.98759 7.29912 5.91799C7.09728 5.85403 6.88226 5.81935 6.65845 5.81935C5.48482 5.81935 4.52501 6.77848 4.52501 7.97228C4.52501 8.514 4.72183 9.00629 5.04755 9.38403C5.21122 9.57383 5.26926 9.83284 5.20226 10.0743C5.13525 10.3158 4.95205 10.5079 4.71398 10.5862C4.15606 10.7698 3.75 11.3005 3.75 11.9297C3.75 12.5621 4.16115 13.0954 4.72372 13.2761C4.9642 13.3534 5.14965 13.5465 5.2171 13.7899C5.28456 14.0333 5.22497 14.2943 5.05856 14.4843C4.72631 14.8637 4.52501 15.3611 4.52501 15.9085C4.52501 17.1023 5.48482 18.0614 6.65845 18.0614C6.881 18.0614 7.09464 18.0271 7.29493 17.964C7.52093 17.8927 7.7673 17.9325 7.95943 18.0712C8.15156 18.2099 8.26684 18.4312 8.27036 18.6681C8.28261 19.4929 8.9496 20.1496 9.76022 20.1496C10.5781 20.1496 11.25 19.4806 11.25 18.6445V17.6299C11.25 17.2156 11.5858 16.8799 12 16.8799C12.4142 16.8799 12.75 17.2156 12.75 17.6299V18.6445C12.75 20.2994 11.4161 21.6496 9.76022 21.6496C8.42083 21.6496 7.29184 20.7664 6.90928 19.5528C6.82633 19.5585 6.74269 19.5614 6.65845 19.5614C4.64682 19.5614 3.02501 17.9211 3.02501 15.9085C3.02501 15.3174 3.16503 14.758 3.41374 14.2631C2.70677 13.7316 2.25 12.8838 2.25 11.9297C2.25 10.9792 2.70295 10.1339 3.40572 9.60192C3.16197 9.11091 3.02501 8.55715 3.02501 7.97228C3.02501 5.95967 4.64682 4.31935 6.65845 4.31935C6.75611 4.31935 6.85296 4.32325 6.94885 4.33091C7.36481 3.1773 8.46355 2.34961 9.76022 2.34961C11.4161 2.34961 12.75 3.69981 12.75 5.35476V6.40232C12.75 6.81654 12.4142 7.15232 12 7.15232C11.5858 7.15232 11.25 6.81654 11.25 6.40232V5.35476C11.25 4.51863 10.5781 3.84961 9.76022 3.84961Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M14.2398 20.1504C15.0241 20.1504 15.6741 19.5352 15.726 18.7477C15.7411 18.5177 15.8611 18.3075 16.0514 18.1776C16.2417 18.0476 16.4812 18.0124 16.7009 18.082C16.9027 18.146 17.1177 18.1807 17.3415 18.1807C18.5152 18.1807 19.475 17.2215 19.475 16.0277C19.475 15.486 19.2782 14.9937 18.9524 14.616C18.7888 14.4262 18.7307 14.1672 18.7977 13.9257C18.8648 13.6842 19.048 13.4921 19.286 13.4138C19.8439 13.2302 20.25 12.6995 20.25 12.0703C20.25 11.4379 19.8388 10.9046 19.2763 10.7239C19.0358 10.6466 18.8504 10.4535 18.7829 10.2101C18.7154 9.96669 18.775 9.70568 18.9414 9.51567C19.2737 9.1363 19.475 8.63892 19.475 8.09152C19.475 6.89772 18.5152 5.93858 17.3415 5.93858C17.119 5.93858 16.9054 5.97288 16.7051 6.03602C16.4791 6.10727 16.2327 6.06752 16.0406 5.92883C15.8484 5.79013 15.7332 5.5688 15.7296 5.33187C15.7174 4.50714 15.0504 3.85039 14.2398 3.85039C13.4219 3.85039 12.75 4.51941 12.75 5.35554C12.75 5.76975 12.4142 6.10554 12 6.10554C11.5858 6.10554 11.25 5.76975 11.25 5.35554C11.25 3.7006 12.5839 2.35039 14.2398 2.35039C15.5792 2.35039 16.7082 3.23361 17.0907 4.4472C17.1737 4.44149 17.2573 4.43858 17.3415 4.43858C19.3532 4.43858 20.975 6.0789 20.975 8.09152C20.975 8.68263 20.835 9.242 20.5863 9.73689C21.2932 10.2684 21.75 11.1162 21.75 12.0703C21.75 13.0208 21.2971 13.8661 20.5943 14.3981C20.838 14.8891 20.975 15.4429 20.975 16.0277C20.975 18.0403 19.3532 19.6807 17.3415 19.6807C17.2439 19.6807 17.147 19.6768 17.0511 19.6691C16.6352 20.8227 15.5364 21.6504 14.2398 21.6504C12.5839 21.6504 11.25 20.3002 11.25 18.6452C11.25 18.231 11.5858 17.8952 12 17.8952C12.4142 17.8952 12.75 18.231 12.75 18.6452C12.75 19.4814 13.4219 20.1504 14.2398 20.1504Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M10.6253 8.75392C10.9219 8.75236 11.1915 8.92567 11.3132 9.19608L13.5601 14.1881C13.7301 14.5659 13.5617 15.0099 13.184 15.1799C12.8062 15.3499 12.3622 15.1815 12.1922 14.8038L10.639 11.3529L9.13238 14.7966C8.96635 15.1761 8.52413 15.3491 8.14464 15.1831C7.76516 15.0171 7.59212 14.5748 7.75814 14.1954L9.94217 9.20329C10.061 8.93161 10.3288 8.75548 10.6253 8.75392Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M12.2897 13.9609L9.0293 13.9609L9.0293 12.4609L12.2897 12.4609L12.2897 13.9609Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M15.2852 8.9375C15.6994 8.9375 16.0352 9.27329 16.0352 9.6875V14.4959C16.0352 14.9101 15.6994 15.2459 15.2852 15.2459C14.8709 15.2459 14.5352 14.9101 14.5352 14.4959V9.6875C14.5352 9.27329 14.8709 8.9375 15.2852 8.9375Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      }
    ]
  },
  ws: {
    name: 'ws',
    viewBox: '0 0 24 10',
    children: [
      {
        name: 'rect',
        attributes: {
          x: 0.5,
          y: 0.5,
          rx: 1.5,
          width: 23,
          height: 9,
          stroke: 'currentColor',
          fill: 'none'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M12.773 2.42L11.576 7.676C11.552 7.772 11.501 7.85 11.423 7.91C11.351 7.97 11.267 8 11.171 8H10.847C10.757 8 10.676 7.973 10.604 7.919C10.532 7.865 10.481 7.796 10.451 7.712L10.415 7.595C10.337 7.349 10.247 7.064 10.145 6.74C10.049 6.416 9.94698 6.077 9.83898 5.723C9.83298 5.699 9.81798 5.687 9.79398 5.687C9.77598 5.687 9.76398 5.699 9.75798 5.723C9.67398 5.987 9.59298 6.251 9.51498 6.515C9.43698 6.773 9.36498 7.007 9.29898 7.217C9.23898 7.427 9.18798 7.592 9.14598 7.712C9.12198 7.79 9.07098 7.859 8.99298 7.919C8.92098 7.973 8.83998 8 8.74998 8H8.41698C8.32098 8 8.23398 7.97 8.15598 7.91C8.08398 7.85 8.03898 7.772 8.02098 7.676L6.82398 2.42C6.79998 2.3 6.82398 2.183 6.89598 2.069C6.94398 2.021 6.99498 1.985 7.04898 1.961C7.10298 1.931 7.16298 1.916 7.22898 1.916H7.48098C7.57698 1.916 7.66098 1.946 7.73298 2.006C7.81098 2.066 7.86198 2.141 7.88598 2.231L8.61498 5.489C8.62098 5.507 8.63598 5.516 8.65998 5.516C8.68398 5.516 8.70198 5.507 8.71398 5.489C8.71398 5.489 8.73198 5.423 8.76798 5.291C8.80998 5.159 8.86398 4.985 8.92998 4.769C8.99598 4.547 9.07098 4.301 9.15498 4.031C9.23898 3.761 9.32298 3.488 9.40698 3.212C9.43698 3.128 9.48498 3.059 9.55098 3.005C9.61698 2.945 9.69798 2.915 9.79398 2.915C9.89598 2.915 9.97998 2.945 10.046 3.005C10.118 3.059 10.166 3.131 10.19 3.221L10.883 5.489C10.895 5.507 10.913 5.516 10.937 5.516C10.961 5.516 10.976 5.507 10.982 5.489C11.06 5.135 11.138 4.784 11.216 4.436C11.294 4.088 11.366 3.764 11.432 3.464C11.504 3.164 11.564 2.906 11.612 2.69C11.66 2.474 11.693 2.321 11.711 2.231C11.735 2.141 11.783 2.066 11.855 2.006C11.933 1.946 12.02 1.916 12.116 1.916H12.368C12.434 1.916 12.494 1.931 12.548 1.961C12.602 1.985 12.65 2.021 12.692 2.069C12.776 2.177 12.803 2.294 12.773 2.42ZM17.1755 6.812C17.1755 7.028 17.1215 7.226 17.0135 7.406C16.9055 7.586 16.7615 7.73 16.5815 7.838C16.4015 7.946 16.2035 8 15.9875 8H14.2595C14.0435 8 13.8425 7.946 13.6565 7.838C13.4765 7.73 13.3325 7.586 13.2245 7.406C13.1165 7.226 13.0625 7.028 13.0625 6.812V6.542C13.0625 6.428 13.1015 6.332 13.1795 6.254C13.2635 6.17 13.3625 6.128 13.4765 6.128H13.7285C13.8365 6.128 13.9295 6.17 14.0075 6.254C14.0915 6.332 14.1335 6.428 14.1335 6.542V6.812C14.1335 6.842 14.1455 6.872 14.1695 6.902C14.1995 6.926 14.2295 6.938 14.2595 6.938H15.9875C16.0175 6.938 16.0445 6.926 16.0685 6.902C16.0925 6.872 16.1045 6.842 16.1045 6.812V5.993C16.1045 5.927 16.0745 5.885 16.0145 5.867L13.8545 5.057C13.6145 4.973 13.4225 4.826 13.2785 4.616C13.1345 4.406 13.0625 4.175 13.0625 3.923V3.113C13.0625 2.891 13.1165 2.69 13.2245 2.51C13.3325 2.33 13.4765 2.186 13.6565 2.078C13.8425 1.97 14.0435 1.916 14.2595 1.916H15.9875C16.2035 1.916 16.4015 1.97 16.5815 2.078C16.7615 2.186 16.9055 2.33 17.0135 2.51C17.1215 2.69 17.1755 2.891 17.1755 3.113V3.356C17.1755 3.47 17.1335 3.566 17.0495 3.644C16.9715 3.722 16.8755 3.761 16.7615 3.761H16.5185C16.4045 3.761 16.3055 3.722 16.2215 3.644C16.1435 3.566 16.1045 3.47 16.1045 3.356V3.113C16.1045 3.029 16.0655 2.987 15.9875 2.987H14.2595C14.2295 2.987 14.1995 2.999 14.1695 3.023C14.1455 3.047 14.1335 3.077 14.1335 3.113V3.923C14.1335 3.995 14.1635 4.04 14.2235 4.058L16.3925 4.868C16.6265 4.952 16.8155 5.099 16.9595 5.309C17.1035 5.519 17.1755 5.747 17.1755 5.993V6.812Z'
        }
      }
    ]
  },
  'ai-digital-key': {
    name: 'ai-digital-key',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M16.3952 20.6082L18.2839 18.7196L17.1682 17.3196L18.2487 16.1588L17.1682 14.7237L18.2471 13.6432L18.2459 12.2152C19.8682 11.503 21 9.88233 21 7.99703C21 5.45406 18.9385 3.39258 16.3955 3.39258C13.8526 3.39258 11.7911 5.45406 11.7911 7.99703C11.7911 9.86546 12.9057 11.474 14.5048 12.1958L14.5066 18.7196L16.3952 20.6082Z',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M15.4205 6.71432C15.9589 6.17595 16.8317 6.17595 17.3701 6.71432',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'circle',
        attributes: {
          cx: '1.22416',
          cy: '1.22416',
          r: '1.22416',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5',
          transform: 'matrix(-1 0 0 1 5.44824 7.23828)'
        }
      },
      {
        name: 'circle',
        attributes: {
          cx: '1.22416',
          cy: '1.22416',
          r: '1.22416',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5',
          transform: 'matrix(-1 0 0 1 5.44824 12.5078)'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M5.45155 13.7324H11.9893',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'circle',
        attributes: {
          cx: '1.22416',
          cy: '1.22416',
          r: '1.22416',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5',
          transform: 'matrix(-1 0 0 1 5.44824 17.7051)'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M12.0161 16.8613H8.99869L7.76962 18.9288H5.45082',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M9 10.6035L7.77089 8.53599H5.45202',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  user: {
    name: 'user',
    viewBox: '0 0 25 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M12.4009 4.75C10.6091 4.75 9.15625 6.20334 9.15625 7.99553C9.15625 9.78771 10.6091 11.2411 12.4009 11.2411C14.1936 11.2411 15.6464 9.78761 15.6464 7.99553C15.6464 6.20345 14.1936 4.75 12.4009 4.75ZM7.65625 7.99553C7.65625 5.37534 9.7803 3.25 12.4009 3.25C15.0223 3.25 17.1464 5.37523 17.1464 7.99553C17.1464 10.6158 15.0223 12.7411 12.4009 12.7411C9.7803 12.7411 7.65625 10.6157 7.65625 7.99553Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M7.76749 14.6744C9.03002 14.251 10.6954 14.125 12.399 14.125C14.1125 14.125 15.7787 14.2556 17.0399 14.6845C17.6745 14.9002 18.2613 15.2093 18.696 15.6649C19.1479 16.1387 19.4035 16.7392 19.4035 17.4461C19.4035 18.1546 19.1453 18.7547 18.6907 19.2265C18.2539 19.6798 17.6651 19.986 17.0299 20.1991C15.7673 20.6227 14.1019 20.7491 12.399 20.7491C10.6859 20.7491 9.01976 20.6185 7.7584 20.1897C7.12379 19.9739 6.53692 19.6649 6.10219 19.2093C5.65018 18.7355 5.39453 18.135 5.39453 17.428C5.39453 16.7195 5.65233 16.1192 6.10685 15.6471C6.5436 15.1935 7.13241 14.8874 7.76749 14.6744ZM7.18739 16.6875C6.99661 16.8856 6.89453 17.1151 6.89453 17.428C6.89453 17.7423 6.99671 17.9739 7.18743 18.1738C7.39543 18.3918 7.73621 18.5978 8.24122 18.7695C9.25914 19.1156 10.7202 19.2491 12.399 19.2491C14.0698 19.2491 15.5317 19.1196 16.5528 18.777C17.0596 18.6069 17.4018 18.4024 17.6105 18.1857C17.8015 17.9875 17.9035 17.7582 17.9035 17.4461C17.9035 17.1318 17.8013 16.9002 17.6106 16.7003C17.4027 16.4824 17.062 16.2763 16.5571 16.1046C15.5393 15.7586 14.0783 15.625 12.399 15.625C10.7271 15.625 9.26531 15.7542 8.24446 16.0965C7.73785 16.2664 7.39595 16.4709 7.18739 16.6875Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      }
    ]
  },
  'user-outline': {
    name: 'user-outline',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M7.93255 3H16.3673C19.3154 3 21.1504 5.08119 21.1504 8.02638V15.9736C21.1504 18.9188 19.3154 21 16.3663 21H7.93255C4.98444 21 3.15039 18.9188 3.15039 15.9736V8.02638C3.15039 5.08119 4.9932 3 7.93255 3Z',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M12.1497 13.9727C10.197 13.9727 8.53125 14.2675 8.53125 15.4496C8.53125 16.6318 10.1882 16.9363 12.1497 16.9363C14.1015 16.9363 15.7682 16.6415 15.7682 15.4594C15.7682 14.2782 14.1122 13.9727 12.1497 13.9727Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M14.4469 9.35872C14.4469 10.6275 13.4185 11.6549 12.1507 11.6549C10.8819 11.6549 9.85352 10.6275 9.85352 9.35872C9.85352 8.08996 10.8819 7.0625 12.1507 7.0625C13.4185 7.0625 14.4469 8.08996 14.4469 9.35872Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  'user-verified': {
    name: 'user-verified',
    viewBox: '0 0 25 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M8.80759 19.7273C8.78559 19.7273 8.76358 19.7273 8.74158 19.7273C5.57958 19.4503 3.97559 18.3843 3.97559 16.5583C3.97559 13.6023 8.18658 13.4143 9.57558 13.3523C9.77449 13.3435 9.96873 13.4142 10.1156 13.5486C10.2624 13.6831 10.3498 13.8704 10.3586 14.0693C10.3673 14.2682 10.2967 14.4625 10.1622 14.6093C10.0278 14.7561 9.8405 14.8435 9.64159 14.8523C6.88059 14.9763 5.48058 15.5523 5.48058 16.5603C5.48058 17.4743 6.62358 18.0373 8.88058 18.2353C9.0795 18.2439 9.26684 18.3312 9.4014 18.478C9.53595 18.6247 9.6067 18.8189 9.59808 19.0178C9.58946 19.2167 9.50217 19.404 9.35542 19.5386C9.20868 19.6732 9.01449 19.7439 8.81558 19.7353L8.80759 19.7273Z'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M16.0965 21.2527C15.6523 21.2536 15.2251 21.0822 14.9045 20.7747C14.8875 20.7597 14.8705 20.7427 14.8545 20.7257L14.5675 20.4387C14.5473 20.4186 14.5232 20.4026 14.4968 20.3918C14.4704 20.381 14.4421 20.3755 14.4135 20.3757H13.9725C13.7463 20.3759 13.5222 20.3316 13.313 20.2453C13.1039 20.1589 12.9138 20.0323 12.7536 19.8724C12.5934 19.7126 12.4663 19.5228 12.3795 19.3139C12.2926 19.1049 12.2478 18.8809 12.2475 18.6547V18.2107C12.2476 18.1814 12.2418 18.1525 12.2304 18.1255C12.2191 18.0985 12.2025 18.0741 12.1815 18.0537L11.8755 17.7467C11.5535 17.4249 11.3718 16.9888 11.3701 16.5335C11.3684 16.0783 11.5469 15.6409 11.8665 15.3167L11.8925 15.2907L12.1845 14.9997C12.2239 14.958 12.2461 14.903 12.2465 14.8457V14.4007C12.2473 13.9447 12.429 13.5076 12.7516 13.1853C13.0742 12.8631 13.5115 12.6819 13.9675 12.6817H14.4095C14.4684 12.6815 14.5248 12.6581 14.5665 12.6167L14.8665 12.3107C15.1887 11.9881 15.6255 11.8062 16.0814 11.8047C16.5373 11.8032 16.9753 11.9822 17.2995 12.3027L17.6145 12.6187C17.635 12.6387 17.6593 12.6545 17.6859 12.6651C17.7125 12.6757 17.7409 12.681 17.7695 12.6807H18.2115C18.4386 12.6792 18.6637 12.7226 18.8739 12.8083C19.0841 12.8941 19.2754 13.0205 19.4366 13.1802C19.5979 13.34 19.7261 13.5301 19.8137 13.7395C19.9014 13.949 19.9469 14.1736 19.9475 14.4007V14.8417C19.9473 14.8704 19.9527 14.8989 19.9635 14.9255C19.9743 14.9521 19.9903 14.9763 20.0105 14.9967L20.3195 15.3077C20.6426 15.6294 20.8246 16.0662 20.8255 16.5221C20.8264 16.978 20.6462 17.4157 20.3245 17.7387L20.0085 18.0537C19.9695 18.0955 19.9477 18.1505 19.9475 18.2077V18.6507C19.947 19.1066 19.7656 19.5437 19.4431 19.866C19.1206 20.1883 18.6835 20.3694 18.2275 20.3697H17.7825C17.7537 20.3696 17.7251 20.3753 17.6985 20.3865C17.6718 20.3976 17.6477 20.414 17.6275 20.4347L17.3185 20.7427C17.1589 20.9045 16.9686 21.0329 16.7588 21.1205C16.549 21.208 16.3239 21.253 16.0965 21.2527ZM15.9455 19.6947C15.9877 19.733 16.043 19.7537 16.0999 19.7524C16.1569 19.7511 16.2112 19.7279 16.2515 19.6877L16.5635 19.3757C16.7231 19.2164 16.9126 19.0902 17.1211 19.0044C17.3296 18.9186 17.5531 18.8749 17.7785 18.8757H18.2225C18.2515 18.8759 18.2802 18.8703 18.3069 18.8593C18.3337 18.8483 18.3581 18.8321 18.3785 18.8117C18.3993 18.7916 18.4157 18.7675 18.4269 18.7408C18.4381 18.7142 18.4437 18.6856 18.4435 18.6567V18.2137C18.4431 17.9887 18.487 17.7659 18.5728 17.5579C18.6586 17.3499 18.7846 17.1609 18.9435 17.0017L19.2575 16.6887C19.2783 16.6678 19.2948 16.643 19.306 16.6157C19.3171 16.5884 19.3228 16.5592 19.3225 16.5297C19.3227 16.5009 19.317 16.4725 19.3059 16.446C19.2947 16.4195 19.2782 16.3956 19.2575 16.3757L18.9455 16.0617C18.7862 15.9023 18.66 15.713 18.5742 15.5046C18.4884 15.2963 18.4447 15.073 18.4455 14.8477V14.4007C18.4453 14.3419 18.4218 14.2856 18.3802 14.244C18.3387 14.2024 18.2823 14.179 18.2235 14.1787H17.7815C17.5561 14.1795 17.3327 14.1357 17.1242 14.0499C16.9157 13.9641 16.7262 13.8379 16.5665 13.6787L16.2545 13.3667C16.234 13.3461 16.2096 13.3298 16.1828 13.3186C16.1559 13.3075 16.1271 13.3017 16.098 13.3017C16.069 13.3017 16.0402 13.3075 16.0133 13.3186C15.9865 13.3298 15.9621 13.3461 15.9415 13.3667L15.6315 13.6767C15.3094 13.9968 14.8737 14.1766 14.4195 14.1767H13.9745C13.9159 14.1767 13.8597 14.2 13.8183 14.2414C13.7768 14.2828 13.7535 14.3391 13.7535 14.3977V14.8407C13.7511 15.2935 13.5717 15.7274 13.2535 16.0497L12.9405 16.3627L12.9295 16.3737C12.8938 16.416 12.875 16.4702 12.8769 16.5256C12.8787 16.581 12.901 16.6338 12.9395 16.6737L13.2505 16.9847C13.4098 17.1443 13.5359 17.3338 13.6217 17.5423C13.7075 17.7508 13.7513 17.9742 13.7505 18.1997V18.6437C13.7505 18.7023 13.7738 18.7585 13.8153 18.7999C13.8567 18.8414 13.9129 18.8647 13.9715 18.8647H14.4125C14.6373 18.8643 14.86 18.9083 15.0678 18.9941C15.2756 19.0799 15.4645 19.2058 15.6235 19.3647L15.9355 19.6757L15.9455 19.6947Z'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M15.6476 18.2071C15.4485 18.2071 15.2575 18.128 15.1167 17.9871L14.2437 17.1132C14.1741 17.0434 14.1189 16.9607 14.0813 16.8696C14.0436 16.7785 14.0243 16.681 14.0244 16.5825C14.0245 16.4839 14.044 16.3864 14.0818 16.2954C14.1196 16.2044 14.1749 16.1217 14.2446 16.0521C14.3144 15.9825 14.3971 15.9274 14.4882 15.8898C14.5793 15.8521 14.6768 15.8328 14.7754 15.8329C14.8739 15.833 14.9714 15.8525 15.0624 15.8903C15.1534 15.9281 15.236 15.9834 15.3056 16.0532L15.6476 16.3961L16.9167 15.1272C16.9859 15.0556 17.0687 14.9985 17.1602 14.9592C17.2517 14.9199 17.3501 14.8993 17.4497 14.8985C17.5493 14.8976 17.648 14.9167 17.7402 14.9544C17.8323 14.9922 17.9161 15.0479 17.9865 15.1184C18.0568 15.1888 18.1125 15.2726 18.1501 15.3648C18.1878 15.457 18.2068 15.5557 18.2058 15.6553C18.2049 15.7549 18.1842 15.8533 18.1448 15.9448C18.1055 16.0363 18.0483 16.119 17.9767 16.1882L16.1767 17.9882C16.1072 18.0577 16.0247 18.1128 15.934 18.1504C15.8432 18.1879 15.7459 18.2072 15.6476 18.2071Z'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M10.8069 12.02C9.89018 12.0202 8.99399 11.7485 8.23166 11.2394C7.46933 10.7303 6.8751 10.0065 6.52411 9.15966C6.17311 8.3128 6.08112 7.38088 6.25976 6.48174C6.43841 5.5826 6.87968 4.75663 7.52775 4.10827C8.17583 3.45991 9.00162 3.01829 9.90068 2.83926C10.7997 2.66022 11.7317 2.75181 12.5787 3.10244C13.4257 3.45307 14.1497 4.04699 14.6592 4.80911C15.1687 5.57122 15.4407 6.46728 15.4409 7.384C15.4396 8.61279 14.951 9.79089 14.0823 10.66C13.2136 11.529 12.0357 12.0181 10.8069 12.02ZM10.8069 4.24999C10.1868 4.24979 9.58052 4.43351 9.06482 4.77792C8.54912 5.12232 8.14713 5.61192 7.90973 6.18481C7.67232 6.75769 7.61016 7.38814 7.73109 7.99636C7.85203 8.60458 8.15063 9.16327 8.58912 9.60177C9.02762 10.0403 9.58631 10.3389 10.1945 10.4598C10.8028 10.5807 11.4332 10.5186 12.0061 10.2812C12.579 10.0437 13.0686 9.64179 13.413 9.12609C13.7574 8.61039 13.9411 8.00413 13.9409 7.384C13.9398 6.55313 13.6093 5.7566 13.0218 5.16909C12.4343 4.58158 11.6378 4.25105 10.8069 4.24999Z'
        }
      }
    ]
  },
  users: {
    name: 'users',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M12.1872 14.875C9.06499 14.875 6.40234 15.3854 6.40234 17.4278C6.40234 19.4713 9.05075 19.999 12.1872 19.999C15.3073 19.999 17.972 19.4876 17.972 17.4451C17.972 15.4037 15.3246 14.875 12.1872 14.875Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M16.1814 7.99549C16.1814 10.2016 14.3931 11.991 12.1859 11.991C9.97972 11.991 8.19141 10.2016 8.19141 7.99549C8.19141 5.78933 9.97972 4 12.1859 4C14.3931 4 16.1814 5.78933 16.1814 7.99549Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M5.68425 13.4258H5.67612C3.95186 13.6942 2.74609 14.3215 2.74609 15.5862C2.74609 16.2389 3.07041 16.7228 3.62449 17.0736',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M18.6172 13.4258H18.6253C20.3496 13.6942 21.5553 14.3215 21.5553 15.5862C21.5553 16.2389 21.231 16.7228 20.6769 17.0736',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M18.3075 10.4081C19.5813 9.93131 20.3164 8.56288 19.9717 7.21478C19.6932 6.12492 18.7894 5.3614 17.7422 5.21094',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M5.99327 10.4081C4.71939 9.93131 3.98435 8.56288 4.32899 7.21478C4.60756 6.12492 5.51137 5.3614 6.55854 5.21094',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  'back-outline': {
    name: 'back-outline',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M20.2634 20.1023C21.2416 19.0515 21.75 17.601 21.75 15.9736L21.75 8.02638C21.75 6.39806 21.2388 4.94771 20.2598 3.89737C19.2753 2.84117 17.8733 2.25 16.2178 2.25L7.78314 2.25C6.12379 2.25 4.72117 2.84084 3.73714 3.89765C2.75872 4.94841 2.25 6.39889 2.25 8.02638L2.25 15.9736C2.25 17.6011 2.75873 19.0516 3.7373 20.1024C4.72148 21.1592 6.12435 21.75 7.78411 21.75L16.2178 21.75C17.8772 21.75 19.2796 21.1591 20.2634 20.1023ZM19.1655 19.0802C18.4952 19.8003 17.5066 20.25 16.2178 20.25L7.78411 20.25C6.49479 20.25 5.5056 19.8002 4.835 19.0801C4.15879 18.354 3.75 17.2913 3.75 15.9736L3.75 8.02638C3.75 6.70868 4.15879 5.64597 4.83492 4.91984C5.50543 4.19975 6.49437 3.75 7.78314 3.75L16.2178 3.75C17.5017 3.75 18.4908 4.19943 19.1625 4.92012C19.8398 5.64666 20.25 6.70951 20.25 8.02638L20.25 15.9736C20.25 17.2914 19.8414 18.3541 19.1655 19.0802Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M13.9338 15.9042C14.2261 15.6107 14.2251 15.1358 13.9315 14.8435L11.0735 11.9978L13.9315 9.15209C14.2251 8.85983 14.2261 8.38496 13.9338 8.09144C13.6416 7.79791 13.1667 7.79689 12.8732 8.08915L9.48138 11.4663C9.34002 11.6071 9.26056 11.7983 9.26056 11.9978C9.26056 12.1973 9.34002 12.3885 9.48137 12.5293L12.8732 15.9065C13.1667 16.1987 13.6416 16.1977 13.9338 15.9042Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      }
    ]
  },
  home: {
    name: 'home',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M6.8052 21.7514C5.78593 21.749 4.80889 21.344 4.08685 20.6246C3.3648 19.9052 2.95626 18.9296 2.9502 17.9104V10.0644C2.95293 9.61532 3.05932 9.17297 3.26104 8.77177C3.46276 8.37058 3.75439 8.02137 4.1132 7.75136L9.99319 3.03336C10.6304 2.52616 11.4208 2.25 12.2352 2.25C13.0496 2.25 13.84 2.52616 14.4772 3.03336L20.4012 7.76336C20.7529 8.03131 21.0391 8.37571 21.2382 8.77053C21.4372 9.16535 21.5439 9.60025 21.5502 10.0424V17.9074C21.5491 18.4153 21.4473 18.9179 21.2506 19.3862C21.0539 19.8545 20.7662 20.2791 20.4042 20.6354C19.6665 21.3405 18.6886 21.7394 17.6682 21.7514H15.9392C15.4535 21.7415 14.9907 21.5428 14.6491 21.1974C14.3074 20.852 14.1138 20.3872 14.1092 19.9014V17.1304C14.1089 17.0611 14.0949 16.9925 14.068 16.9286C14.041 16.8648 14.0017 16.8069 13.9522 16.7584C13.8526 16.6599 13.7183 16.6046 13.5782 16.6044H10.9722C10.8318 16.6052 10.6973 16.6612 10.5979 16.7604C10.4986 16.8596 10.4422 16.994 10.4412 17.1344V19.8954C10.4411 19.9602 10.4327 20.0247 10.4162 20.0874C10.3673 20.5444 10.1511 20.9672 9.80921 21.2744C9.4673 21.5816 9.02385 21.7515 8.5642 21.7514H6.8052ZM13.5822 15.1014C14.1188 15.1024 14.6331 15.3158 15.0129 15.6948C15.3927 16.0739 15.6071 16.5878 15.6092 17.1244V19.9014C15.6102 19.9935 15.6469 20.0817 15.7117 20.1474C15.7764 20.2131 15.864 20.251 15.9562 20.2534H17.6852C18.3103 20.2536 18.91 20.0063 19.3532 19.5656C19.7964 19.1248 20.047 18.5264 20.0502 17.9014V10.0554C20.0458 9.83887 19.9923 9.6262 19.8938 9.4334C19.7952 9.2406 19.6541 9.0727 19.4812 8.94236L13.5442 4.20136C13.1725 3.90541 12.7114 3.74427 12.2362 3.74427C11.761 3.74427 11.2999 3.90541 10.9282 4.20136L5.0352 8.93436C4.85606 9.0657 4.70987 9.23687 4.60818 9.43435C4.50648 9.63184 4.45206 9.85025 4.4492 10.0724V17.9064C4.45394 18.5294 4.70458 19.1254 5.14657 19.5646C5.58856 20.0038 6.18612 20.2506 6.8092 20.2514H8.5612C8.6573 20.2519 8.74969 20.2143 8.81812 20.1468C8.88654 20.0793 8.92541 19.9875 8.9262 19.8914C8.92658 19.8427 8.9316 19.7941 8.9412 19.7464V17.1304C8.94462 16.5934 9.15971 16.0795 9.53979 15.7001C9.91986 15.3208 10.4342 15.1067 10.9712 15.1044H13.5822V15.1014Z'
        }
      }
    ]
  },
  'left-side': {
    name: 'left-side',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M7.78216 3H16.2169C19.165 3 21 5.08119 21 8.02638V15.9736C21 18.9188 19.165 21 16.2159 21H7.78216C4.83405 21 3 18.9188 3 15.9736V8.02638C3 5.08119 4.84281 3 7.78216 3Z',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M8.54199 3V21',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M15.6488 9.39844L12.8447 12.0021L15.6488 14.6058',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  'right-side': {
    name: 'right-side',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M16.2178 21H7.78313C4.83503 21 3 18.9188 3 15.9736V8.02638C3 5.08119 4.83503 3 7.78411 3H16.2178C19.1659 3 21 5.08119 21 8.02638V15.9736C21 18.9188 19.1572 21 16.2178 21Z',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M15.458 21V3',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M8.35156 14.6058L11.1557 12.0021L8.35156 9.39844',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  question: {
    name: 'question',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M8.50898 20.5877C11.8405 22.1341 15.9153 21.5376 18.665 18.7777C22.1765 15.2543 22.1823 9.53724 18.665 6.00703C15.1535 2.48463 9.44888 2.48463 5.93738 6.00703C3.18773 8.76696 2.59227 12.8546 4.13445 16.1974C4.33196 16.6924 4.48569 17.0897 4.48569 17.4753C4.48569 18.5531 3.44947 19.8877 4.14028 20.5809C4.8311 21.274 6.16117 20.2343 7.2295 20.2284C7.61286 20.2284 8.01665 20.3885 8.50898 20.5877Z',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M12.0762 16.2539L12.082 16.2891',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M12.0767 14.0062C12.066 13.1852 12.8104 12.8376 13.364 12.5203C14.0383 12.1474 14.4956 11.5528 14.4956 10.7288C14.4956 9.50752 13.5109 8.52734 12.3015 8.52734C11.0843 8.52734 10.1074 9.50752 10.1074 10.7288',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  'question-mark': {
    name: 'question-mark',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M12 21C7.02908 21 3 16.9699 3 12C3 7.02908 7.02908 3 12 3C16.9709 3 21 7.02908 21 12C21 15.4826 19.0216 18.5037 16.1271 20',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M11.9473 16.2245V16.1963',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M11.9462 13.7496C11.9345 12.8583 12.745 12.4808 13.3473 12.1373C14.0819 11.7326 14.5791 11.0875 14.5791 10.1933C14.5791 8.86815 13.5078 7.80469 12.1914 7.80469C10.8662 7.80469 9.80267 8.86815 9.80267 10.1933',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  wallet: {
    name: 'wallet',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M17.1929 10.0958C16.2091 10.0958 15.4122 10.8933 15.4122 11.8764C15.4122 12.8607 16.2093 13.658 17.1929 13.658H21C21.4143 13.658 21.75 13.9938 21.75 14.408C21.75 14.8223 21.4143 15.158 21 15.158H17.1929C15.3801 15.158 13.9122 13.6884 13.9122 11.8764C13.9122 10.0652 15.3803 8.59576 17.1929 8.59576H21C21.4143 8.59576 21.75 8.93155 21.75 9.34576C21.75 9.75997 21.4143 10.0958 21 10.0958H17.1929Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M16.2433 11.8223C16.2433 11.4081 16.5791 11.0723 16.9933 11.0723H16.9962C17.4104 11.0723 17.7462 11.4081 17.7462 11.8223C17.7462 12.2365 17.4104 12.5723 16.9962 12.5723H16.9933C16.5791 12.5723 16.2433 12.2365 16.2433 11.8223Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M7.93586 4.43951C5.62386 4.43951 3.75006 6.31331 3.75006 8.62531V15.3747C3.75006 17.6867 5.62386 19.5605 7.93586 19.5605H16.064C18.376 19.5605 20.2498 17.6867 20.2498 15.3747V8.62531C20.2498 6.31331 18.376 4.43951 16.064 4.43951H7.93586ZM2.25006 8.62531C2.25006 5.48488 4.79543 2.93951 7.93586 2.93951H16.064C19.2044 2.93951 21.7498 5.48488 21.7498 8.62531V15.3747C21.7498 18.5151 19.2044 21.0605 16.064 21.0605H7.93586C4.79543 21.0605 2.25006 18.5151 2.25006 15.3747V8.62531Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M6.51666 7.95905C6.51666 7.54484 6.85245 7.20905 7.26666 7.20905H12.3455C12.7597 7.20905 13.0955 7.54484 13.0955 7.95905C13.0955 8.37326 12.7597 8.70905 12.3455 8.70905H7.26666C6.85245 8.70905 6.51666 8.37326 6.51666 7.95905Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      }
    ]
  },
  'wallet-add': {
    name: 'wallet-add',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M20.9981 14.4061H17.1909C15.7927 14.4061 14.6602 13.2726 14.6602 11.8745C14.6602 10.4773 15.7927 9.34375 17.1909 9.34375H20.9981',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M16.9966 11.8185H16.9936',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M3 11.6114V8.62339C3 5.89712 5.20962 3.6875 7.93589 3.6875H16.0641C18.7904 3.6875 21 5.89712 21 8.62339V15.3729C21 18.0992 18.7904 20.3088 16.0641 20.3088H11.6974',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M8.43795 17.592H3',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M5.71793 20.309V14.8711',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  'cloud-share': {
    name: 'cloud-share',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M7.11705 7.88469C4.85419 7.90526 3.02539 9.42549 3.02539 12.0144C3.02539 13.6889 4.02208 15.1299 5.45488 15.7769C6.05762 16.0217 6.65831 16.1153 7.11396 16.1153H16.8802C17.3369 16.1153 17.9386 16.0258 18.5496 15.7821C19.9814 15.1341 20.975 13.6889 20.975 12.0144C20.975 9.42549 19.1472 7.90526 16.8844 7.88469C16.8844 6.25646 15.6069 3 12.0007 3C8.39453 3 7.11705 6.25646 7.11705 7.88469Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M12 20.7244V16.3711',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M7.85898 16.3711V18.9425C7.85898 20.0787 6.93797 20.9997 5.80184 20.9997H4.49805',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M16.1133 16.3711V18.9425C16.1133 20.0787 17.0343 20.9997 18.1704 20.9997H19.4742',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  clock: {
    name: 'clock',
    viewBox: '0 0 25 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M12.499 21H8.28216C5.33308 21 3.5 18.9188 3.5 15.9736V8.02638C3.5 5.08119 5.34281 3 8.28216 3H16.7169C19.665 3 21.5 5.08119 21.5 8.02638V15.9736C21.5 18.9188 19.665 21 16.7159 21H16.0954',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M15.7994 13.9634L12.5 11.9951V7.75195',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  copy: {
    name: 'copy',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M14.9572 5.47322C14.7283 3.9968 13.6651 3 12.0629 3H6.86577C5.0565 3 3.91992 4.28509 3.91992 6.10048V12.7954C3.91992 14.4491 4.86518 15.6678 6.41498 15.86',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M17.1354 8.11328H11.94C10.1298 8.11328 8.99414 9.39488 8.99414 11.2094V17.9043C8.99414 19.7188 10.1237 21.0004 11.94 21.0004H17.1345C18.9517 21.0004 20.0812 19.7188 20.0812 17.9043V11.2094C20.0812 9.39488 18.9517 8.11328 17.1354 8.11328Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  information: {
    name: 'information',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M21 15.0944C21 17.8596 19.1552 20.1072 16.4183 20.1004H7.58173C4.84476 20.1072 3 17.8596 3 15.0944V8.91315C3 6.15088 4.84476 3.90039 7.58173 3.90039H16.4183C19.1552 3.90039 21 6.15088 21 8.91315V15.0944Z',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M6.69141 13.0078H9.39141M6.69141 15.8825H12.9914',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M16.7515 10.8165H14.2665C13.9581 10.8165 13.709 10.5665 13.709 10.259V8.22646C13.709 7.91803 13.9581 7.66895 14.2665 7.66895H16.7515C17.0589 7.66895 17.309 7.91803 17.309 8.22646V10.259C17.309 10.5665 17.0589 10.8165 16.7515 10.8165Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  send: {
    name: 'send',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M8.8049,11.8178 L12.4619,17.7508 C12.6219,18.0108 12.8719,18.0078 12.9729,17.9938 C13.0739,17.9798 13.3169,17.9178 13.4049,17.6228 L17.9779,2.1778 C18.0579,1.9048 17.9109,1.7188 17.8449,1.6528 C17.7809,1.5868 17.5979,1.4458 17.3329,1.5208 L1.8769,6.0468 C1.5839,6.1328 1.5199,6.3788 1.5059,6.4798 C1.4919,6.5828 1.4879,6.8378 1.7469,7.0008 L7.7479,10.7538 L13.0499,5.3958 C13.3409,5.1018 13.8159,5.0988 14.1109,5.3898 C14.4059,5.6808 14.4079,6.1568 14.1169,6.4508 L8.8049,11.8178 Z M12.8949,19.4998 C12.1989,19.4998 11.5609,19.1458 11.1849,18.5378 L7.3079,12.2468 L0.9519,8.2718 C0.2669,7.8428 -0.0911,7.0788 0.0199,6.2758 C0.1299,5.4728 0.6809,4.8348 1.4549,4.6078 L16.9109,0.0818 C17.6219,-0.1262 18.3839,0.0708 18.9079,0.5928 C19.4319,1.1198 19.6269,1.8898 19.4149,2.6038 L14.8419,18.0478 C14.6129,18.8248 13.9729,19.3738 13.1719,19.4808 C13.0779,19.4928 12.9869,19.4998 12.8949,19.4998 L12.8949,19.4998 Z',
          transform: 'translate(2.000000, 3.000000)'
        }
      }
    ]
  },
  accrual: {
    name: 'accrual',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M15.436,0 C19.063,0 21.5,2.546 21.5,6.335 L21.5,15.165 C21.5,18.954 19.063,21.5 15.436,21.5 L6.064,21.5 C2.437,21.5 0,18.954 0,15.165 L0,6.335 C0,2.546 2.437,0 6.064,0 L15.436,0 Z M15.436,1.5 L6.064,1.5 C3.292,1.5 1.5,3.397 1.5,6.335 L1.5,15.165 C1.5,18.103 3.292,20 6.064,20 L15.436,20 C18.209,20 20,18.103 20,15.165 L20,6.335 C20,3.397 18.209,1.5 15.436,1.5 Z M10.75,6.3273 C11.164,6.3273 11.5,6.6633 11.5,7.0773 L11.5,9.99 L14.4165,9.9902 C14.8305,9.9902 15.1665,10.3262 15.1665,10.7402 C15.1665,11.1542 14.8305,11.4902 14.4165,11.4902 L11.5,11.49 L11.5,14.4043 C11.5,14.8183 11.164,15.1543 10.75,15.1543 C10.336,15.1543 10,14.8183 10,14.4043 L10,11.49 L7.0835,11.4902 C6.6685,11.4902 6.3335,11.1542 6.3335,10.7402 C6.3335,10.3262 6.6685,9.9902 7.0835,9.9902 L10,9.99 L10,7.0773 C10,6.6633 10.336,6.3273 10.75,6.3273 Z',
          transform: 'translate(1.000000, 1.000000)'
        }
      }
    ]
  },
  subtract: {
    name: 'subtract',
    viewBox: '0 0 25 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M16.0508 11.7424C16.0508 12.1566 15.7148 12.4924 15.3008 12.4924H8.70117C8.28711 12.4924 7.95117 12.1566 7.95117 11.7424C7.95117 11.3282 8.28711 10.9924 8.70117 10.9924H15.3008C15.7148 10.9924 16.0508 11.3282 16.0508 11.7424Z'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M3.74121 3.64734C4.7251 2.59119 6.12793 2 7.7832 2H16.2178C17.877 2 19.2798 2.59082 20.2632 3.64771C21.2422 4.69849 21.75 6.14905 21.75 7.77637V15.7236C21.75 17.351 21.2422 18.8015 20.2632 19.8523C19.2788 20.9092 17.877 21.5 16.2168 21.5H7.7832C6.12402 21.5 4.72119 20.9092 3.73682 19.8524C2.75879 18.8016 2.25 17.3511 2.25 15.7236V7.77637C2.25 6.14795 2.76123 4.69763 3.74121 3.64734ZM4.83789 4.67017C4.16016 5.39673 3.75 6.45959 3.75 7.77637V15.7236C3.75 17.0413 4.15918 18.104 4.83496 18.8302C5.50488 19.5503 6.49414 20 7.7832 20H16.2168C17.5059 20 18.4951 19.5502 19.165 18.8302C19.8408 18.1041 20.25 17.0414 20.25 15.7236V7.77637C20.25 6.45862 19.8408 5.39587 19.165 4.6698C18.4951 3.94971 17.5068 3.5 16.2178 3.5H7.7832C6.49902 3.5 5.51025 3.94946 4.83789 4.67017Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      }
    ]
  },
  'search-close': {
    name: 'search-close',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M11.8819 3.75C7.64733 3.75 4.21484 7.18249 4.21484 11.4171C4.21484 15.6518 7.64744 19.0851 11.8819 19.0851C13.89 19.0851 15.7177 18.313 17.0845 17.0495C17.0951 17.0392 17.1058 17.0292 17.1168 17.0196C18.6135 15.6201 19.549 13.6278 19.549 11.4171C19.549 7.18249 16.1165 3.75 11.8819 3.75ZM18.6687 17.5801C20.1477 15.952 21.049 13.7897 21.049 11.4171C21.049 6.35406 16.9449 2.25 11.8819 2.25C6.8189 2.25 2.71484 6.35406 2.71484 11.4171C2.71484 16.48 6.81879 20.5851 11.8819 20.5851C14.032 20.5851 16.0092 19.8448 17.5725 18.6052L20.5049 21.5309C20.7981 21.8235 21.273 21.823 21.5655 21.5297C21.8581 21.2365 21.8576 20.7616 21.5643 20.4691L18.6687 17.5801ZM9.65211 9.18822C9.94501 8.89533 10.4199 8.89533 10.7128 9.18822L11.8812 10.3567L13.0497 9.18822C13.3426 8.89533 13.8175 8.89533 14.1103 9.18822C14.4032 9.48111 14.4032 9.95599 14.1103 10.2489L12.9419 11.4173L14.1103 12.5858C14.4032 12.8787 14.4032 13.3536 14.1103 13.6465C13.8175 13.9393 13.3426 13.9393 13.0497 13.6465L11.8812 12.478L10.7128 13.6465C10.4199 13.9393 9.94501 13.9393 9.65211 13.6465C9.35922 13.3536 9.35922 12.8787 9.65211 12.5858L10.8206 11.4173L9.65211 10.2489C9.35922 9.95599 9.35922 9.48111 9.65211 9.18822Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      }
    ]
  },
  search: {
    name: 'search',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M11.8824 3.75C7.64753 3.75 4.21484 7.18268 4.21484 11.4175C4.21484 15.6525 7.64764 19.086 11.8824 19.086C13.881 19.086 15.701 18.3212 17.0658 17.0682C17.0703 17.0635 17.0749 17.0588 17.0795 17.0541C17.0979 17.0357 17.117 17.0185 17.1367 17.0024C18.6223 15.6038 19.5499 13.6189 19.5499 11.4175C19.5499 7.18268 16.1172 3.75 11.8824 3.75ZM18.6696 17.5808C20.1486 15.9526 21.0499 13.7903 21.0499 11.4175C21.0499 6.35426 16.9456 2.25 11.8824 2.25C6.8191 2.25 2.71484 6.35426 2.71484 11.4175C2.71484 16.4807 6.81899 20.586 11.8824 20.586C14.0326 20.586 16.0099 19.8456 17.5733 18.6059L20.5059 21.531C20.7992 21.8235 21.274 21.8229 21.5666 21.5296C21.8591 21.2364 21.8585 20.7615 21.5652 20.469L18.6696 17.5808ZM12.8651 6.52275C12.9856 6.12645 13.4046 5.90289 13.8008 6.02341C15.434 6.52006 16.7243 7.78976 17.2483 9.40968C17.3758 9.80378 17.1597 10.2266 16.7656 10.3541C16.3715 10.4816 15.9487 10.2655 15.8212 9.87138C15.4481 8.71823 14.5277 7.81227 13.3644 7.45851C12.9681 7.338 12.7446 6.91904 12.8651 6.52275Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      }
    ]
  },
  mandarin: {
    name: 'mandarin',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M6.48909 2.5H17.5109C19.714 2.5 21.5 4.28598 21.5 6.48909V17.5109C21.5 19.714 19.714 21.5 17.5109 21.5H6.48909C4.28598 21.5 2.5 19.714 2.5 17.5109V6.48909C2.5 4.28598 4.28598 2.5 6.48909 2.5Z',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M5.1001 17.9001C5.15352 16.9785 5.21362 15.9902 5.2804 14.9351C5.34718 13.8799 5.42064 12.8181 5.50078 11.7497C5.58091 10.6678 5.66773 9.64611 5.76121 8.68448C5.85471 7.70949 5.96155 6.84803 6.08176 6.1001H8.98668C9.16031 6.42064 9.36734 6.83468 9.60774 7.3422C9.84815 7.84973 10.1086 8.41068 10.3891 9.02506C10.6695 9.63943 10.95 10.2672 11.2305 10.9082C11.5243 11.5493 11.7914 12.157 12.0318 12.7313C12.5527 11.556 13.0068 10.541 13.3942 9.68618C13.7815 8.81804 14.1154 8.09013 14.3959 7.50248C14.6763 6.91482 14.9101 6.44735 15.097 6.1001H17.8617C17.9819 6.86139 18.0887 7.72285 18.1823 8.68448C18.2758 9.64611 18.3626 10.6612 18.4427 11.7296C18.5228 12.7981 18.5963 13.8599 18.6631 14.915C18.7298 15.9702 18.7899 16.9652 18.8434 17.9001H15.9184C15.9051 17.3792 15.885 16.8316 15.8583 16.2573C15.8316 15.6697 15.8049 15.0686 15.7782 14.4543C15.7515 13.8399 15.7181 13.2055 15.678 12.551C15.638 11.8966 15.5912 11.2288 15.5378 10.5476C15.3775 10.935 15.1839 11.3957 14.9568 11.93C14.7297 12.4642 14.496 13.0185 14.2556 13.5928C14.0152 14.1537 13.7815 14.688 13.5544 15.1955C13.3407 15.703 13.1604 16.1237 13.0135 16.4577H10.95C10.8832 16.2974 10.7497 15.9902 10.5493 15.5361C10.349 15.0686 10.1153 14.5344 9.84815 13.9334C9.59438 13.3324 9.33394 12.7313 9.06681 12.1303C8.81306 11.5293 8.59269 11.0084 8.40571 10.5677C8.33892 11.3957 8.27882 12.2238 8.22539 13.0519C8.18532 13.8666 8.15194 14.6813 8.12523 15.496C8.09851 16.2974 8.0718 17.0987 8.04508 17.9001H5.1001Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      }
    ]
  },
  tinkoff: {
    name: 'tinkoff',
    viewBox: '0 -1 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M2.5 2.5H21.5V12.0585C21.5 14.4585 20.2197 16.6762 18.1414 17.8763L12 21.4226L5.85862 17.8763L5.60859 18.3093L5.85862 17.8763C3.78028 16.6762 2.5 14.4585 2.5 12.0585V2.5Z',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M6.50008 6V9.75526C7.0136 9.17538 7.94726 8.78292 9.01478 8.78292H10.1749V13.1484C10.1749 14.3098 9.85932 15.3264 9.39111 15.8855H14.4373C13.9701 15.3258 13.6552 14.3105 13.6552 13.1506V8.78292H14.8154C15.8829 8.78292 16.8165 9.17538 17.3301 9.75526V6H6.50008Z',
          'fill-rule': 'evenodd',
          'clip-rule': 'evenodd',
          fill: '#333333'
        }
      }
    ]
  },
  stripe: {
    name: 'stripe',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M6.48909 2.5H17.5109C19.714 2.5 21.5 4.28598 21.5 6.48909V17.5109C21.5 19.714 19.714 21.5 17.5109 21.5H6.48909C4.28598 21.5 2.5 19.714 2.5 17.5109V6.48909C2.5 4.28598 4.28598 2.5 6.48909 2.5Z',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M11.293 9.53084C11.293 9.01909 11.7158 8.78917 12.3981 8.78917C13.5288 8.81362 14.6383 9.10053 15.6392 9.62725V6.59383C14.6094 6.19003 13.5115 5.98857 12.4055 6.0005C9.76517 6.0005 8 7.38 8 9.70884C8 13.3133 12.9543 12.7274 12.9543 14.2849C12.9543 14.8857 12.4278 15.0785 11.7083 15.0785C10.441 15.0086 9.2071 14.6456 8.10383 14.0179V17.1255C9.22802 17.6113 10.4392 17.8636 11.6638 17.8672C14.3709 17.8672 16.2399 16.5322 16.2399 14.1588C16.2622 10.2948 11.293 10.9919 11.293 9.53084Z',
          'fill-rule': 'evenodd',
          'clip-rule': 'evenodd'
        }
      }
    ]
  },
  notifications: {
    name: 'notifications',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M9.93262 19.9746C10.4366 20.6041 11.1926 21.0001 12.0293 21.0001C12.8748 21.0001 13.6308 20.6041 14.1348 19.9746',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M4.66406 13.9973C4.88201 16.6107 7.13343 17.2616 11.9992 17.2616C16.864 17.2616 19.1154 16.6195 19.3343 13.9973C19.3343 11.3859 17.764 11.5533 17.764 8.34932C17.764 5.84687 15.4892 3 11.9992 3C8.50919 3 6.23442 5.84687 6.23442 8.35029C6.23442 11.5542 4.66406 11.3879 4.66406 13.9973Z',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  slack: {
    name: 'slack',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M16.1666 10.9338C16.3586 10.6078 16.4306 10.2548 16.4306 9.88079C16.4306 8.32279 16.4316 6.76479 16.4296 5.20679C16.4296 5.05879 16.4286 4.90979 16.4146 4.76179C16.3496 4.06479 16.0106 3.53979 15.3856 3.22379C15.1706 3.11579 14.9186 3.07879 14.6836 3.00879H14.3866C14.2866 3.02879 14.1846 3.04279 14.0856 3.06779C13.2066 3.29779 12.6426 4.02279 12.6406 4.94379C12.6366 6.60479 12.6386 8.26579 12.6406 9.92779C12.6406 10.4458 12.8036 10.9058 13.1676 11.2858C14.0366 12.1898 15.5316 12.0138 16.1666 10.9338Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M4.29386 11.861C6.02486 11.879 7.75586 11.89 9.48686 11.864C10.7189 11.846 11.5659 10.756 11.3179 9.57497C11.1349 8.70397 10.3859 8.09496 9.47286 8.08196C9.03186 8.07596 8.59086 8.08097 8.14986 8.08097C6.87686 8.08196 5.60286 8.06596 4.32986 8.08996C3.59386 8.10396 3.04786 8.47896 2.71686 9.13596C2.61886 9.32996 2.57786 9.55397 2.51086 9.76297V10.159C2.51986 10.194 2.53286 10.229 2.53786 10.265C2.65386 11.122 3.42786 11.852 4.29386 11.861Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M6.21874 13.1474C5.61274 13.1474 5.00674 13.1454 4.40074 13.1484C3.53474 13.1524 2.86674 13.7064 2.61974 14.4194C2.57274 14.5544 2.54674 14.6964 2.51074 14.8354V15.2314C2.51874 15.2534 2.53174 15.2754 2.53474 15.2994C2.69474 16.3854 3.66574 17.0914 4.75074 16.9104C5.59474 16.7684 6.27574 15.9984 6.29274 15.1424C6.30574 14.5084 6.29774 13.8734 6.29874 13.2384C6.29874 13.2104 6.29074 13.1834 6.28574 13.1544C6.25874 13.1514 6.23874 13.1474 6.21874 13.1474Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M10.2495 3.18728C10.0515 3.09528 9.82549 3.06628 9.61149 3.00928H9.31449C9.23849 3.02328 9.16249 3.03728 9.08649 3.05328C8.16849 3.25528 7.56149 4.03328 7.58449 4.97728C7.60749 5.94328 8.39749 6.76028 9.36049 6.79028C10.0025 6.81028 10.6465 6.79828 11.2895 6.79928C11.3125 6.79928 11.3355 6.79228 11.3575 6.78828C11.3575 6.10428 11.3895 5.42728 11.3485 4.75428C11.3035 4.02728 10.9115 3.49528 10.2495 3.18728Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M9.51813 13.1501C8.49313 13.1091 7.59813 13.9461 7.58613 14.9721C7.57513 15.8331 7.58313 16.6951 7.58313 17.5571C7.58313 18.3771 7.58113 19.1981 7.58313 20.0181C7.58313 20.1491 7.59013 20.2821 7.60813 20.4121C7.72413 21.2551 8.47413 21.9501 9.32013 22.0041C10.4371 22.0741 11.3601 21.2271 11.3641 20.1121C11.3711 18.4261 11.3701 16.7401 11.3641 15.0531C11.3611 14.0001 10.5691 13.1921 9.51813 13.1501Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M19.7188 13.1579C18.8368 13.1399 17.9538 13.1539 17.0718 13.1539C16.1898 13.1539 15.3068 13.1349 14.4248 13.1579C13.3118 13.1879 12.4708 14.2539 12.6678 15.3499C12.8408 16.3069 13.5968 16.9369 14.5848 16.9379C16.2468 16.9399 17.9078 16.9389 19.5698 16.9379C19.6528 16.9379 19.7358 16.9409 19.8168 16.9299C20.9518 16.7759 21.6198 15.7539 21.4658 14.7489C21.3358 13.8959 20.5828 13.1759 19.7188 13.1579Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M14.6647 18.2294C14.0227 18.2104 13.3797 18.2214 12.7367 18.2194C12.7087 18.2194 12.6817 18.2264 12.6517 18.2304C12.6467 18.2504 12.6407 18.2664 12.6407 18.2824C12.6447 18.9574 12.6267 19.6344 12.6597 20.3084C12.7047 21.2014 13.5317 21.9684 14.4237 22.0074C15.5957 22.0574 16.5147 21.0784 16.4197 19.9494C16.3437 19.0444 15.5687 18.2554 14.6647 18.2294Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M17.8627 11.8726C18.4107 11.8726 18.9597 11.8736 19.5077 11.8716C19.6067 11.8716 19.7067 11.8726 19.8037 11.8596C20.9447 11.7126 21.6237 10.6876 21.4667 9.67959C21.3037 8.62359 20.2367 7.87759 19.2017 8.12059C18.2987 8.33359 17.7087 9.07559 17.7057 10.0056C17.7037 10.5826 17.7047 11.1596 17.7057 11.7366C17.7057 11.7776 17.7087 11.8176 17.7107 11.8726H17.8627Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      }
    ]
  },
  'folder-file': {
    name: 'folder-file',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M5.09665 4.88841C4.52468 5.60638 4.22461 6.73388 4.22461 8.34168V15.6546C4.22461 17.1846 4.6735 18.3078 5.41535 19.0482C6.1574 19.7888 7.28389 20.2374 8.81913 20.2374H16.1155C17.6464 20.2374 18.7698 19.7891 19.51 19.0488C20.2502 18.3084 20.6984 17.185 20.6984 15.6546L20.6984 15.6503L20.7246 10.9989C20.7246 10.9982 20.7246 10.9974 20.7246 10.9967C20.7243 9.34966 20.42 8.28723 19.863 7.63506C19.329 7.00979 18.4323 6.61421 16.8694 6.61421H14.2161L14.214 6.61421C13.3062 6.61159 12.4519 6.18456 11.9054 5.45983L11.9047 5.45893L11.0488 4.32027C10.7858 3.96997 10.3739 3.76367 9.93739 3.76367H8.06229C6.53644 3.76367 5.6402 4.20612 5.09665 4.88841ZM3.92343 3.95377C4.83479 2.80978 6.23239 2.26367 8.06229 2.26367H9.93739C10.8473 2.26367 11.7025 2.69295 12.2478 3.41896C12.2479 3.41906 12.2477 3.41886 12.2478 3.41896L13.1031 4.55672C13.1032 4.55691 13.1029 4.55653 13.1031 4.55672C13.3667 4.90593 13.7791 5.11265 14.2173 5.11421H16.8694C18.6701 5.11421 20.0759 5.57458 21.0037 6.66095C21.9082 7.72012 22.2246 9.22438 22.2246 10.9989L22.2246 11.0031L22.1984 15.6546C22.1984 15.6553 22.1984 15.6561 22.1984 15.6568C22.1979 17.4802 21.6575 19.0224 20.5707 20.1093C19.4834 21.1968 17.9404 21.7374 16.1155 21.7374H8.81913C6.99085 21.7374 5.44509 21.1971 4.35575 20.1099C3.26622 19.0225 2.72461 17.4793 2.72461 15.6546V8.34168C2.72461 6.59858 3.0405 5.06208 3.92343 3.95377Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M11.498 15.7207C11.498 15.3065 11.8338 14.9707 12.248 14.9707H16.1916C16.6058 14.9707 16.9416 15.3065 16.9416 15.7207C16.9416 16.1349 16.6058 16.4707 16.1916 16.4707H12.248C11.8338 16.4707 11.498 16.1349 11.498 15.7207Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      }
    ]
  },
  utm: {
    name: 'utm',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M12 21H15.9736C18.9188 21 21 19.165 21 16.2169V7.78216C21 4.84281 18.9188 3 15.9736 3H8.02638C5.08119 3 3 4.83405 3 7.78216V16.2159C3 19.165 5.08119 21 8.02638 21H8.37933',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M8.84 10.8164L8.24721 11.4092C7.04976 12.6067 7.04976 14.5587 8.24721 15.7561C9.44054 16.9494 11.3967 16.9536 12.5941 15.7561L13.1869 15.1633',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M15.1606 13.1917L15.7534 12.5989C16.9509 11.4015 16.9509 9.44947 15.7534 8.25201C14.5601 7.05869 12.604 7.05455 11.4065 8.25201L10.8137 8.8448',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M13.3626 10.6875L10.6584 13.3917',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '1.5'
        }
      }
    ]
  },
  refresh: {
    name: 'refresh',
    viewBox: '0 0 24 24',
    children: [
      {
        name: 'path',
        attributes: {
          d: 'M17.1867 14.3326C17.5903 14.2393 17.9931 14.4908 18.0864 14.8944L18.5986 17.11L20.8307 16.5939C21.2343 16.5006 21.6371 16.7522 21.7304 17.1557C21.8237 17.5593 21.5721 17.9621 21.1686 18.0554L18.2057 18.7404C18.0119 18.7852 17.8082 18.7512 17.6395 18.6458C17.4708 18.5405 17.3508 18.3724 17.306 18.1786L16.6249 15.2323C16.5316 14.8287 16.7831 14.4259 17.1867 14.3326Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M6.36029 5.35213C6.52901 5.45749 6.64897 5.62555 6.69377 5.81936L7.37489 8.76569C7.46819 9.16926 7.21666 9.57205 6.81309 9.66535C6.40952 9.75864 6.00673 9.50712 5.91344 9.10355L5.40125 6.88795L3.16911 7.40402C2.76554 7.49733 2.36275 7.24581 2.26944 6.84224C2.17614 6.43867 2.42766 6.03588 2.83122 5.94257L5.7941 5.25756C5.9879 5.21275 6.19157 5.24677 6.36029 5.35213Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M10.444 3.01053C15.4088 2.15156 20.1299 5.47997 20.9888 10.4447C21.4982 13.3886 20.5345 16.2469 18.6332 18.2635C18.3491 18.5648 17.8744 18.5788 17.573 18.2947C17.2716 18.0105 17.2577 17.5358 17.5418 17.2345C19.1331 15.5466 19.9362 13.1594 19.5108 10.7005C18.7931 6.55199 14.8482 3.77084 10.6998 4.48857C10.2916 4.55919 9.90349 4.28556 9.83288 3.87741C9.76226 3.46926 10.0359 3.08114 10.444 3.01053Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      },
      {
        name: 'path',
        attributes: {
          d: 'M6.47594 5.66127C6.77507 5.9478 6.78528 6.42256 6.49875 6.72169C4.87978 8.41183 4.0589 10.8193 4.48803 13.2996C5.20577 17.4481 9.1506 20.2292 13.2991 19.5115C13.7072 19.4409 14.0953 19.7145 14.1659 20.1227C14.2366 20.5308 13.9629 20.9189 13.5548 20.9895C8.59002 21.8485 3.86895 18.5201 3.00999 13.5553C2.49623 10.5858 3.48125 7.70338 5.41553 5.68408C5.70205 5.38495 6.17682 5.37474 6.47594 5.66127Z',
          'clip-rule': 'evenodd',
          'fill-rule': 'evenodd'
        }
      }
    ]
  }
}
